/* global _satellite */
'use strict';
require('../../icons/toastCross.svg');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 * @param {Object} productName - name of the product which was added/removed to/from the wishlist
 */
function displayMessageAndChangeIcon(data, icon, productName) {
    $.spinner().stop();
    if (data.success) {
        if (icon.hasClass('icon-wishlist-o')) {
            icon.removeClass('icon-wishlist-o').addClass('icon-wishlist-s');
            $('.wishlistTile').blur();
        }
        if (window.cfCacheEnabled) {
            $.cookie('isDynamicData', true, { expires: 30, path: '/' });
        }
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages add-to-wishlist-wrapper" tabindex="0"></div>');
    }
    if ($('.add-remove-wishlist-container').length) {
        $('.add-remove-wishlist-container').remove();
    }
    $('.add-to-wishlist-messages').append(
        '<div role="alert" aria-describedby="dialogWishlist" class="add-remove-wishlist-container">' +
            ' <span id="dialogWishlist"> ' +
            data.msg.replace('[PRODUCT NAME]', productName) +
            `</span>
                <button id="closeButton" aria-label="Close" class="close-wishlist-toast">
                    <svg class="icon icon-cross">
                        <use xlink:href="#toastCross"></use>
                    </svg>
                </button>
            </div>`
    );

    setTimeout(function () {
        $('.add-to-wishlist-messages').focus();
    }, 900);

    setTimeout(() => {
        $('.add-to-wishlist-messages').addClass('show-toast');
    }, 10);

    $('.add-to-wishlist-alert a').on('click', function () {
        _satellite.track('wishlist-banner-link');
    });
    if ($('.sticky-section.bottom-sticky').hasClass('sticky-size-add-to-cart')) {
        var stickyHeight = $('.sticky-size-add-to-cart').height() + 25;
        $('.add-to-wishlist-wrapper').attr('style', 'bottom: ' + stickyHeight + 'px !important');
    } else {
        $('.add-to-wishlist-wrapper').removeAttr('style');
    }

    if ($('.quiz-toast-wrapper').hasClass('in-view') && !$('.compare-bar-wrapper').hasClass('visible')) {
        var $target = $('.quiz-toast-wrapper');
        var $toast = $('.add-to-wishlist-messages');

        var targetHeight = $target.outerHeight();
        var topValue = targetHeight + 16 + 'px';
        $toast[0].style.setProperty('bottom', topValue, 'important');
        setTimeout(() => {
            $('.add-to-wishlist-messages').removeClass('show-toast');
            $toast[0].style.setProperty('bottom', '-100px');
        }, 6000);
    }

    // If compare bar is visible, place wishlist toast above it
    if ($('.compare-bar-wrapper').hasClass('visible')) {
        var compareHeight = $('.compare-bar-wrapper').height() + 16 + 'px';
        $('.add-to-wishlist-messages')[0].style.setProperty('bottom', compareHeight, 'important');
    }
}

/**
 * updates the state of wishlist button
 * @param {Object} currentElement - icon that was clicked to add a product to the wishlist
 * @param {string} data - data returned from the server's ajax call
 * @param {boolean} isRemoveProductFromWishlist flag to check if user has removed a product from wishlist
 * @param {boolean} isPDPWishlistIcon flag to check if user triggers wishlist action from PDP
 */
function updateRemoveFromWishlistIconState(currentElement, data, isRemoveProductFromWishlist, isPDPWishlistIcon) {
    if (data.success) {
        var wishlistItems = JSON.parse(localStorage.getItem('wishlistItems'));
        if (isRemoveProductFromWishlist) {
            var icon = currentElement.find($('i'));
            var productIDIndex = '';
            if (icon.hasClass('icon-wishlist-s')) {
                icon.removeClass('icon-wishlist-s').addClass('icon-wishlist-o');
                $('.wishlistTile').blur();
            }
            if (isPDPWishlistIcon) {
                currentElement.attr('href', data.addToWishlistURL);
                productIDIndex = wishlistItems.indexOf($('.product-detail input[name=productID]').val());
            } else {
                productIDIndex = wishlistItems.indexOf(currentElement.parents('.product-tile').attr('id'));
            }
            if (productIDIndex > -1) {
                wishlistItems.splice(productIDIndex, 1);
            }
            currentElement.removeClass('remove-from-wishlist');
            currentElement.attr('title', currentElement.data('add-wishlist'));
        } else {
            if (isPDPWishlistIcon) {
                currentElement.attr('href', data.removeFromWishlistURL);
            }
            wishlistItems.push(data.pid);
            currentElement.addClass('remove-from-wishlist');
            currentElement.attr('title', currentElement.data('remove-wishlist'));
        }

        localStorage.setItem('wishlistItems', JSON.stringify(wishlistItems));
    }
    // Event listener for the close button
    $(document).on('click', '.add-to-wishlist-messages #closeButton', function () {
        $(this).parent().parent().removeClass('show-toast');
        setTimeout(() => {
            $(this).parent().parent().remove();
        }, 1200);
        currentElement.focus();
    });
    // Swipe down to remove notification in mobile and tablet devices
    if (window.matchMedia('(max-width: 1023.98px)').matches) {
        var startY;
        $(document).on('touchstart', '.add-to-wishlist-wrapper', function (event) {
            // Store the starting Y-coordinate
            startY = event.originalEvent.touches[0].clientY;
        });

        $(document).on('touchend', '.add-to-wishlist-wrapper', function (event) {
            // Calculate the vertical distance travelled
            var deltaY = event.originalEvent.changedTouches[0].clientY - startY;
            // Checking if the distance is significant to be considered a swipe down
            if (deltaY > 20) {
                // Swipe down detected
                $(this).removeClass('show-toast');
                setTimeout(() => {
                    $(this).remove();
                }, 1200);
                currentElement.focus();
            }
        });
    }
}

document.body.addEventListener('mousedown', function () {
    $('.wishlistTile').addClass('using-mouse');
});

document.body.addEventListener('keydown', function (event) {
    if (event.keyCode === 9) {
        $('.wishlistTile').removeClass('using-mouse');
    }
});

$(document).ready(function () {
    $('.wishlistTile').hover(function (e) {
        e.stopPropagation();
    });
});

$('.wishlistTile').on('contextmenu', function () {
    this.blur();
});

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', function (e) {
            e.preventDefault();
            var isPDPWishlistIcon = $(e.target).parent('.wishlistTile').hasClass('main-prod-image') || $(e.target).parent('.wishlistTile').hasClass('main-prod-image-pdp');
            var currentElement = $(this);
            var methodType = 'post';
            var icon = currentElement.find($('i'));
            let pid;
            let productName;
            // checking if added from PDP
            const $pdpSku = $('.product-detail.skuAlignmentNewPDP .product-id');
            if ($pdpSku.length > 0 && currentElement.parents('.wishlist-icon-pdp').length > 0) {
                pid = $('.wishlist-icon-pdp').attr('data-pid');
                productName = $(this).closest('.product-detail').data('productname');
            } else {
                pid = $(this)
                    .closest('.product')
                    .data('pid');
                productName = $(this)
                    .closest('.product').find('.search-results-product-name').html();
            }
            var optionId = $(this)
                .closest('.product-detail')
                .find('.product-option')
                .attr('data-option-id');
            var optionVal = $(this)
                .closest('.product-detail')
                .find('.options-select option:selected')
                .attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            var recommender = '';
            var wishlistAddRecommender = '';
            var wishlistRemoveRecommender = '';
            var wishlistAdd = 'wishlist-add-click';
            var wishlistRemove = '';
            var wishlistLocation = '';
            // Event type based on page
            if ($('.container .search-results').length) {
                wishlistAddRecommender = 'wishlist-add-recommender-cdp';
                wishlistRemoveRecommender = 'wishlist-remove-recommender-cdp';
                wishlistAdd = 'wishlist-add-cdp';
                wishlistRemove = 'wishlist-remove-cdp';
            }

            if ($('.container.search-results').length) {
                wishlistLocation = 'cdp';
            } else if ($('#home-page-indicator').length) {
                wishlistLocation = 'homepage';
            }

            // Tracking clicks on CDP recommender product tiles.
            if ($(this).parents('.einstein-recommender').length) {
                recommender = 'cdp-recommendations-bestSellers';
            } else if ($(this).parents('.ai-recommender').length) {
                recommender = 'cdp-recommendations-bestSellers-ai';
            }

            var requestData;
            var isRemoveProductFromWishlist = currentElement.hasClass('remove-from-wishlist');
            var url = '';
            if (isPDPWishlistIcon) {
                url = $(this).attr('href');
                if (isRemoveProductFromWishlist) {
                    methodType = 'get';
                    requestData = {
                        optionId: optionId,
                        optionVal: optionVal
                    };
                } else {
                    requestData = {
                        pid: pid,
                        optionId: optionId,
                        optionVal: optionVal
                    };
                }
            } else {
                url = '';
                if (isRemoveProductFromWishlist) {
                    url = $(this).attr('data-remove-url');
                    methodType = 'get';
                    requestData = {
                        optionId: optionId,
                        optionVal: optionVal
                    };
                    if (recommender) {
                        _satellite.track(wishlistRemoveRecommender, {
                            recommenderName: recommender,
                            product: [{
                                productId: pid
                            }]
                        });
                    } else {
                        _satellite.track(wishlistRemove, {
                            product: [{
                                productId: pid
                            }]
                        });
                    }
                } else {
                    url = $(this).attr('data-add-url');
                    requestData = {
                        pid: pid,
                        optionId: optionId,
                        optionVal: optionVal
                    };
                    if (recommender) {
                        _satellite.track(wishlistAddRecommender, {
                            recommenderName: recommender,
                            product: [{
                                productId: pid
                            }]
                        });
                    } else if ($('.wishlistTile.main-prod-image-pdp').length === 0) {
                        _satellite.track(wishlistAdd, {
                            wishlistLocation: wishlistLocation,
                            product: [{
                                sku: '',
                                productId: pid
                            }]
                        });
                    }
                }
            }

            if (!url || !pid) {
                return;
            }

            var $container = $('.hybrid-size-tabs-ul');
            var $activeNavLink = $container ? $container.find('.nav-link.active') : [];
            if ($activeNavLink && $activeNavLink.length > 0) {
                requestData.countryForHybridSizing = $activeNavLink.data('sizetab-country-for-wishlist');
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: methodType,
                dataType: 'json',
                data: requestData,
                success: function (data) {
                    displayMessageAndChangeIcon(data, icon, productName);
                    updateRemoveFromWishlistIconState(currentElement, data, isRemoveProductFromWishlist, isPDPWishlistIcon);
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, icon, productName);
                }
            });
        });

        $('body').on('click', '.main-prod-image.wishlistTile', function (e) {
            e.preventDefault();
            var isPDPWishlistIcon = $(e.target).parent('.wishlistTile').hasClass('main-prod-image');
            var currentElement = $(this);
            var methodType = 'post';
            var icon = currentElement.find($('i'));
            var url = $(this).attr('href');
            var pid = $('input[name=productID]').val();

            if (!url || !pid) {
                return;
            }
            var requestData;
            var isRemoveProductFromWishlist = currentElement.hasClass('remove-from-wishlist');
            if (isRemoveProductFromWishlist) {
                methodType = 'get';
                requestData = {};
            } else {
                requestData = {
                    pid: pid
                };
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: methodType,
                dataType: 'json',
                data: requestData,
                success: function (data) {
                    displayMessageAndChangeIcon(data, icon);
                    updateRemoveFromWishlistIconState(currentElement, data, isRemoveProductFromWishlist, isPDPWishlistIcon);
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, icon);
                }
            });
        });
        $(document).on('click', '.add-to-wishlist-messages .link', function () {
            var url = $(this).attr('data-href');
            window.open(url, '_self');
        });
    }
};
